import { useThemeStore } from "@/stores/ThemeStore";

const links = {
  tunnl: {
    ccpa: "https://www.tunnldata.com/privacy-policy#Notice-to-California-Residents",
    contact: "https://www.tunnldata.com/upgrade",
    cookies: "https://www.tunnldata.com/cookie-policy",
    halo: "https://www.tunnldata.com/halo",
    home: "https://www.tunnldata.com",
    pricing: "https://www.tunnldata.com/upgrade",
    privacy: "https://www.tunnldata.com/privacy-policy",
    privacy_request: "https://privacy.tunnldata.com",
  },
  deeproot: {
    ccpa: "https://www.deeprootanalytics.com/privacy-policy#Notice-to-California-Residents",
    contact: "https://www.deeprootanalytics.com/#form",
    cookies: "https://www.deeprootanalytics.com/cookie-policy",
    halo: "https://www.deeprootanalytics.com/#DRA_Products",
    home: "https://www.deeprootanalytics.com",
    pricing: "https://www.deeprootanalytics.com/#DRA_Products",
    privacy: "https://www.deeprootanalytics.com/privacy-policy",
    privacy_request: "https://privacy.deeprootanalytics.com",
  },
};

export const getLink = (type, message = undefined) => {
  const themeStore = useThemeStore();
  const activeTheme = themeStore.activeTheme?.name || "tunnl";
  return activeTheme !== "deeproot" && message
    ? `${links[activeTheme][type]}?message=${message}`
    : links[activeTheme][type];
};
